import React, {useEffect, useState, useLayoutEffect, createRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {completePage, gotoNextPage, setAudio, setAudioEvent, toggleResources} from "../../store/actions/course.action";

import './Page.sass';
import config from '../../config/config_data';
import gsap from "gsap"
import VideoJS from "../ui/Video/VideoJS";
import Content from './components/Content/Content';
import Shape from './components/Shape/Shape';
import Image from './components/Image/Image';
import TextItem from './components/TextItem/TextItem';
import Activities from '../Activities';
import Panel from "./components/Panel/Panel";
import SlideShow from "../ui/SlideShow/SlideShow";
import renderHTML from 'react-render-html';
import Quote from "./components/Quote/Quote";
import _ from "lodash"

const Page = ({content}) => {
    const SUPPORTED_TWEEN_PROPS = ["x", "y", "opacity", "rotation", "scale"];
    const {elements, style, classNames, id, background, audio} = content;
    const audioEvent = useSelector((state) => state.course.audioEvent);
    const audioStatus = useSelector((state) => state.course.audioStatus);
    const debug = useSelector((state) => state.course.debug)
    const dispatch = useDispatch();
    const [pageTimeline, setPageTimeline] = useState(null);

    useEffect(() => {
        return () => {
            cleanupTimeline();
        }
    }, [])


    useLayoutEffect(() => {
        dispatch(setAudio(audio));
        let tl = createTimeline(elements);
        if (tl) {
            setPageTimeline(tl);
        }
    }, []);

    useEffect(() => {
        gsap.set(".page", {"visibility": "visible"})
        if (pageTimeline) {
            pageTimeline.play();
        }
    }, [pageTimeline]);

    useEffect(() => {
        if (audioEvent && pageTimeline) {
            pageTimeline.seek(audioEvent.target.currentTime)
        }
    }, [audioEvent]);


    useEffect(() => {
        if (!pageTimeline) return;
        if (audioStatus === "audioPaused") {
            pageTimeline.pause();
        } else if (audioStatus === "audioPlaying") {
            pageTimeline.play();
        }
    }, [audioStatus]);


    const cleanupTimeline = () => {
        if (!pageTimeline) return
        pageTimeline.clear();
        setPageTimeline(null);
    }

    const createTimeline = (elements, timeline) => {
        //console.log("Page createTimeline(",elements,")");
        let tl = timeline ? timeline : gsap.timeline({paused: true})
        if (!elements) {
            tl.to('.page', {opacity: 1, duration: 0.1});
            return tl;
        }
        elements.map((element, index) => {
            if (element.type == "panel") {
                createTimeline(element.elements, tl);
            }
            _.forEach(element.animations, (anim) => {
                let {delay, duration, ease} = anim;
                let d = (duration != 0 && !isNaN(duration)) ? duration : 1;
                let e = ease ? ease : "expo.out"
                //console.log(element.id + " " + anim.type);
                _.forIn(anim, (val, key) => {
                    if (!document.querySelector("#" + element.id)) {
                        //console.log("ELEMENT NOT FOUND");
                        return null;
                    }
                    if (SUPPORTED_TWEEN_PROPS.indexOf(key) !== -1) {
                        //console.log("   key: ", key);
                        //console.log("   val: ", val);
                        if (anim.type == "from") {
                            tl.from("#" + element.id, {
                                [key]: val,
                                duration: d,
                                ease: e,
                                transformOrigin: "50% 50%"
                            }, delay)
                        } else {
                            tl.to("#" + element.id, {
                                [key]: val,
                                duration: d,
                                ease: e,
                                transformOrigin: "50% 50%"
                            }, delay)
                        }
                    }
                });
                gsap.set("#" + element.id, {visibility: "visible"})
            })
        })
        return tl;
    }

    const complete = () => {
        dispatch(completePage());
    };

    const next = () => {
        dispatch(gotoNextPage());
    }

    const getElement = (event) => {
        var att = event.target.getAttribute("id");
        var cl = event.target.getAttribute("class");
        if (cl === "resources-link") {
            dispatch(toggleResources(true, att))
        }
    }

    const getActivity = (element) => {
        const TagName = element.activity ? Activities[element.activity] : null;
        return TagName ? <TagName data={element.data}
                                  key={element.activity}
                                  completed={complete}
                                  next={next}/> : null;
    }

    return (
        <div id="page"
             onClick={(event) => {
                 getElement(event)
             }}
             className={`page relative ${classNames || ''}`}
             style={style || {}}>
            {background && <div className="bg-image">
                <img src={background}/>
            </div>}
            {
                debug && <div className="page-id">
                    {renderHTML("page-id: <b>" + content.id + "</b>")}
                </div>
            }

            {elements && elements.map((element, index) => {
                switch (element.type) {
                    case 'shape':
                        return <Shape data={element}
                                      key={index}/>;
                        break;
                    case 'image':
                        return <Image data={element}
                                      key={index}/>;
                        break;
                    case 'content':
                        return <Content data={element}
                                        key={index}/>;
                        break;
                    case 'text':
                        return <TextItem data={element}
                                         key={index}/>;
                        break;
                    case "panel":
                        return <Panel data={element}
                                      key={index}/>
                        break;
                    case "slideshow":
                        return <SlideShow data={element}
                                          key={index}/>
                        break;
                    case "quote":
                        return <Quote data={element}
                                      key={index}/>
                        break;
                    case "video":
                        return  <VideoJS src={element.url} style={{
                            width: "100%",
                            height: "100%"
                        }}/>
                        break;
                    default:
                        return getActivity(element);
                }
            })}
        </div>
    );
};

export default Page;
